import { Lang } from "../i18n/languages";

export const UTC_TZ = "UTC";

export type TimeZoneString = string;
export type LocaleString = string;

export interface DateLocale {
    dateLocale: LocaleString;// fr-FR - used by luxon
    timeZone: TimeZoneString | typeof UTC_TZ;
}
export interface Locale extends DateLocale {
    lang: Lang;// fr - used by i18n
    phoneLocale: PhoneLocale;
}

export type PhoneLocale = "FR" | "GB" | string

export const FR_LOCALE: Locale = {
    lang: "fr", timeZone: "Europe/Paris", dateLocale: "fr-FR", phoneLocale: "FR"
};

export const UK_LOCALE: Locale = {
    lang: "en", timeZone: "Europe/London", dateLocale: "en-GB", phoneLocale: "GB"
};

export const US_LOCALE: Locale = {
    lang: "en", timeZone: "America/New_York", dateLocale: "en-US", phoneLocale: "US"
};

/** 
 * UTC const can be used as format or parse parameter to indicate we want to parse/format in UTC timezone 
 * * with current lang and dateLocale 
 */
export const UTC: Partial<Locale> = {
    timeZone: UTC_TZ
};